import { render, staticRenderFns } from "./OptionDetailComponent.vue?vue&type=template&id=86aebe10&scoped=true&"
import script from "./OptionDetailComponent.vue?vue&type=script&lang=js&"
export * from "./OptionDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./OptionDetailComponent.vue?vue&type=style&index=0&id=86aebe10&lang=scss&scoped=true&"
import style1 from "./OptionDetailComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aebe10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/35827007/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86aebe10')) {
      api.createRecord('86aebe10', component.options)
    } else {
      api.reload('86aebe10', component.options)
    }
    module.hot.accept("./OptionDetailComponent.vue?vue&type=template&id=86aebe10&scoped=true&", function () {
      api.rerender('86aebe10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/OptionDetailComponent.vue"
export default component.exports